import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { MutationLinkCallToCustomerAndLocationArgs } from '@api/generated/graphql';
import { retryMutation } from '@api/lib/retryMutate';
import { LINK_CALL_TO_CUSTOMER_AND_LOCATION_OPERATION_NAME } from 'src/constants/operations';

export const LINK_CALL_TO_CUSTOMER_AND_LOCATION = graphql(`
  mutation LinkCallToCustomerAndLocation(
    $tenantId: ID!
    $channelId: ID!
    $customerId: ID!
    $locationId: ID!
  ) {
    linkCallToCustomerAndLocation(
      tenantId: $tenantId
      channelId: $channelId
      customerId: $customerId
      locationId: $locationId
    )
  }
`);

export const linkCallToCustomerAndLocation = async (
  variables: MutationLinkCallToCustomerAndLocationArgs,
): Promise<void> => {
  try {
    const result = await retryMutation(
      () =>
        getClient().mutate({
          mutation: LINK_CALL_TO_CUSTOMER_AND_LOCATION,
          variables,
        }),
      {
        operationName: LINK_CALL_TO_CUSTOMER_AND_LOCATION_OPERATION_NAME,
        shouldRetryForGraphQLErrors: (errOrResult: any) => {
          return !errOrResult?.data?.linkCallToCustomerAndLocation;
        },
      },
    );

    if (!result?.data?.linkCallToCustomerAndLocation) {
      throw new Error('Failed to link call to customer and location');
    }
  } catch (error) {
    console.error('Error linking call to customer and location:', error);
    throw error;
  }
};
